export default __webpack_public_path__ + "static/media/DIGITAL_CITIZENSHIP.df2f9f48.svg";